import {useEffect, useState} from "react";

function InfoPercorso(props){

    const [percorso,setPercorso] = useState([])
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}
    useEffect(()=>{
        creazionePercorso()
    },[props.percorso])


    function creazionePercorso(){
        let newPercorso = []
        if(props.percorso){
            props.percorso.forEach(function(value, idx, array){
                let step
                if (idx === array.length - 1){
                    step = (
                        <span style={{fontSize:"14px"}}><b>{value}</b></span>
                    )
                }else{
                    step = (
                        <span style={{fontSize:"14px"}}>{value} >&ensp;</span>
                    )
                }
                newPercorso.push(step)
            });
        }
        setPercorso(newPercorso)
    }

    return (
        <div className={"row"} style={{margin:"1rem",display:sessioneUtente && (sessioneUtente.tipoUtente === "02" ||sessioneUtente.tipoUtente === "03" )?"none":""}}>
            {percorso}
        </div>
    )


}
export default InfoPercorso